import React from 'react';
import 'whatwg-fetch';
import { itemsPerPage } from 'src/data/params';

import ModalTaskPost from '../components/modal/modalTaskPost';
import ModalAppointmentPost from '../components/modal/modalAppointmentPost';
import ModalReminderPost from '../components/modal/modalReminderPost';
import ModalNotePost from '../components/modal/modalNotePost';
import MyPlanning from './myPlanning';
import SubNavBar from '../components/SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiTask = '/api/task/';
const apiAppointment = '/api/appointment/';
const apiReminder = '/api/reminder/';
const apiNote = '/api/note/';

class AppPlanning extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      offsetTask: 0,
      offsetAppointment: 0,
      offsetReminder: 0,
      offsetNote: 0,
      selectedView: 1,
      currentCollaborativeType: undefined,
      isModalPostTaskOpen: false,
      isModalPostAppointmentOpen: false,
      isModalPostReminderOpen: false,
      isModalPostNoteOpen: false,
      entity: undefined,
      dataTask: undefined,
      dataAppointment: undefined,
      dataReminder: undefined,
      dataNote: undefined,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.postResult = this.postResult.bind(this);
    this.deleteCollaborative = this.deleteCollaborative.bind(this);
    this.seeMore = this.seeMore.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    this.refreshSearchTask(0, 0, -1, -1, -1);
    this.refreshSearchAppointment(0, 0, -1);
    this.refreshSearchReminder(0, 0, -1);
    this.refreshSearchNote(0);
  }

  refreshSearchTask(offsetNb, closed, state, criticity, priority) {
    this.setState({ pendingHasMoreTask: true });
    let queryURL = apiTask;
    let graphQL =
      '{ tasks( offset:' +
      itemsPerPage['task_planning'] * offsetNb +
      ', limit:' +
      itemsPerPage['task_planning'] +
      ', closed: ' +
      closed +
      ', state: ' +
      state +
      ', criticity: ' +
      criticity +
      ', priority: ' +
      priority +
      '){ hasMore, items{ id,  title, deadline, criticity, priority, state, closed } } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['tasks']['items']) {
            this.setState({
              offsetTask: offsetNb, // increment or reset the current offset
              hasMoreTask: data['data']['tasks']['hasMore'],
              pendingHasMoreTask: false,
              dataTask:
                offsetNb > 0
                  ? this.state.dataTask.concat(data['data']['tasks']['items'])
                  : data['data']['tasks']['items'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch task list');
        }.bind(this)
      );
  }

  refreshSearchAppointment(offsetNb, closed, criticity) {
    this.setState({ pendingHasMoreAppointment: true });
    let queryURL = apiAppointment;
    let graphQL =
      '{ appointments( offset:' +
      itemsPerPage['appointment_planning'] * offsetNb +
      ', limit:' +
      itemsPerPage['appointment_planning'] +
      ', closed: ' +
      closed +
      ', criticity: ' +
      criticity +
      '){ hasMore, items{ id,  title, dateMeeting, criticity, state, closed } } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['appointments']['items']) {
            this.setState({
              offsetAppointment: offsetNb, // increment or reset the current offset
              hasMoreAppointment: data['data']['appointments']['hasMore'],
              pendingHasMoreAppointment: false,
              dataAppointment:
                offsetNb > 0
                  ? this.state.dataAppointment.concat(data['data']['appointments']['items'])
                  : data['data']['appointments']['items'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch appointment list');
        }.bind(this)
      );
  }

  refreshSearchReminder(offsetNb, closed, criticity) {
    this.setState({ pendingHasMoreReminder: true });
    let queryURL = apiReminder;
    let graphQL =
      '{ reminders( offset:' +
      itemsPerPage['reminder_planning'] * offsetNb +
      ', limit:' +
      itemsPerPage['reminder_planning'] +
      ', closed: ' +
      closed +
      ', criticity: ' +
      criticity +
      '){ hasMore, items{ id,  title, dateRecall, criticity, state, closed } } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['reminders']['items']) {
            this.setState({
              offsetReminder: offsetNb, // increment or reset the current offset
              hasMoreReminder: data['data']['reminders']['hasMore'],
              pendingHasMoreReminder: false,
              dataReminder:
                offsetNb > 0
                  ? this.state.dataReminder.concat(data['data']['reminders']['items'])
                  : data['data']['reminders']['items'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch reminder list');
        }.bind(this)
      );
  }

  refreshSearchNote(offsetNb) {
    this.setState({ pendingHasMoreNote: true });
    let queryURL = apiNote;
    let graphQL =
      '{ notes( offset:' +
      itemsPerPage['note_planning'] * offsetNb +
      ', limit:' +
      itemsPerPage['note_planning'] +
      '){ hasMore, items{ id,  title, dateCreate, state, closed } } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['notes']['items']) {
            this.setState({
              offsetNote: offsetNb, // increment or reset the current offset
              hasMoreNote: data['data']['notes']['hasMore'],
              pendingHasMoreNote: false,
              dataNote:
                offsetNb > 0
                  ? this.state.dataNote.concat(data['data']['notes']['items'])
                  : data['data']['notes']['items'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch note list');
        }.bind(this)
      );
  }

  seeMore(type, resetOffset, closed = -1, state = -1, criticity = -1, priority = -1) {
    let offset;
    switch (type) {
      case 'task':
        offset = resetOffset ? 0 : this.state.offsetTask + 1;
        this.refreshSearchTask(offset, closed, state, criticity, priority);
        break;
      case 'appointment':
        offset = resetOffset ? 0 : this.state.offsetAppointment + 1;
        this.refreshSearchAppointment(offset, closed, criticity);
        break;
      case 'reminder':
        offset = resetOffset ? 0 : this.state.offsetReminder + 1;
        this.refreshSearchReminder(offset, closed, criticity);
        break;
      case 'note':
        offset = resetOffset ? 0 : this.state.offsetNote + 1;
        this.refreshSearchNote(offset);
        break;
    }
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  render() {
    const { dataTask } = this.state;
    const { dataAppointment } = this.state;
    const { dataReminder } = this.state;
    const { dataNote } = this.state;

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
          goBack={this.props.history.goBack}
          appViewNavExtended={this.state.appViewNavExtended}
          title='Planning'
        >
          <div className={'appViewNavMenu-alignRight'}>
            <button onClick={() => this.openModal('task')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Tâche</span>
            </button>
            <button
              onClick={() => this.openModal('appointment')}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              <span className='icon icon-plus'>Rdv</span>
            </button>
            <button onClick={() => this.openModal('reminder')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Rappel</span>
            </button>
            <button onClick={() => this.openModal('note')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Note</span>
            </button>
          </div>
        </SubNavBar>

        <div id='appViewContent'>
          <MyPlanning
            dataTask={dataTask}
            dataAppointment={dataAppointment}
            dataReminder={dataReminder}
            dataNote={dataNote}
            hasMoreTask={this.state.hasMoreTask}
            hasMoreAppointment={this.state.hasMoreAppointment}
            hasMoreReminder={this.state.hasMoreReminder}
            hasMoreNote={this.state.hasMoreNote}
            pendingHasMoreTask={this.state.pendingHasMoreTask}
            pendingHasMoreAppointment={this.state.pendingHasMoreAppointment}
            pendingHasMoreReminder={this.state.pendingHasMoreReminder}
            pendingHasMoreNote={this.state.pendingHasMoreNote}
            seeMore={this.seeMore}
            deleteCollaborative={this.deleteCollaborative}
          />
        </div>

        <ModalTaskPost
          className='myModal'
          isOpen={this.state.isModalPostTaskOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalAppointmentPost
          className='myModal'
          isOpen={this.state.isModalPostAppointmentOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalReminderPost
          className='myModal'
          isOpen={this.state.isModalPostReminderOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalNotePost
          className='myModal'
          isOpen={this.state.isModalPostNoteOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />
      </div>
    );
  }

  switchStep(newStep) {
    this.setState({
      selectedView: newStep,
    });
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalPostTaskOpen: false,
      isModalPostAppointmentOpen: false,
      isModalPostReminderOpen: false,
      isModalPostNoteOpen: false,
    });
  }

  openModal(type) {
    let toOpen = undefined;
    switch (type) {
      case 'task':
        toOpen = 'isModalPostTaskOpen';
        break;
      case 'appointment':
        toOpen = 'isModalPostAppointmentOpen';
        break;
      case 'reminder':
        toOpen = 'isModalPostReminderOpen';
        break;
      case 'note':
        toOpen = 'isModalPostNoteOpen';
        break;
    }
    this.props.toggleBlackOut();
    this.setState({
      [toOpen]: true,
      appViewNavExtended: false,
    });
  }

  postResult(type, promise) {
    let messageLabel = 'entité';
    let afterView = 1;
    switch (type) {
      case 'task':
        messageLabel = 'tâche';
        afterView = 1;
        break;
      case 'appointment':
        messageLabel = 'rdv';
        afterView = 2;
        break;
      case 'reminder':
        messageLabel = 'rappel';
        afterView = 3;
        break;
      case 'note':
        messageLabel = 'note';
        afterView = 4;
        break;
    }
    promise.then(
      function (result) {
        if (result.wentFine) {
          this.props.openToast(true, result.error ? result.error : '' + 'Succès création ' + messageLabel);
          this.componentDidMount();
          this.setState({ selectedView: afterView });
        } else {
          this.props.openToast(false, 'Erreur création ' + messageLabel + '. Veuillez réessayer');
        }
      }.bind(this)
    );
  }

  deleteCollaborative(id, type) {
    let afterView = 1;
    let json = {
      [type]: {
        id: id,
      },
    };
    let collaborative = {
      type: undefined,
      message: undefined,
      apiUrl: undefined,
    };
    switch (type) {
      case 'task':
        collaborative.type = 'task';
        collaborative.message = 'tâche';
        collaborative.apiUrl = apiTask;
        afterView = 1;
        break;
      case 'appointment':
        collaborative.type = 'appointment';
        collaborative.message = 'rendez-vous';
        collaborative.apiUrl = apiAppointment;
        afterView = 2;
        break;
      case 'reminder':
        collaborative.type = 'reminder';
        collaborative.message = 'rappel';
        collaborative.apiUrl = apiReminder;
        afterView = 3;
        break;
      case 'note':
        collaborative.type = 'note';
        collaborative.message = 'note';
        collaborative.apiUrl = apiNote;
        afterView = 4;
        break;
    }
    let queryURL = collaborative.apiUrl;
    let tabParam = encodeURIComponent(JSON.stringify(json));
    queryURL += tabParam;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          // perform setState here
          let isValid = data.isValid;
          console.log(data);
          if (isValid) {
            this.componentDidMount();
            this.setState({ selectedView: afterView });
            this.props.openToast(true, 'Suppression réalisée ');
          } else {
            this.props.openToast(false, 'Erreur suppression. Veuillez réessayer');
          }
        }.bind(this)
      )
      .catch(
        function (rror) {
          console.log(rror);
          this.props.openToast(false, 'Impossible à supprimer');
        }.bind(this)
      );
  }
}

export default withAuth(AppPlanning);
